import { CloseOutlined } from '@ant-design/icons';
import { t } from 'i18next';
import { Link } from 'react-router-dom';

import { usePermissions } from 'business/contextProviders/usePermissions';
import Routes from 'config/routes';
import Button, { ButtonProps } from 'ui/button';

interface ExitReportButtonProps extends Omit<ButtonProps, 'icon'> {
  previousLocation?: string;
  managerRoute?: string | null;
}

const ExitReportButton = ({
  previousLocation,
  managerRoute,
  ...buttonProps
}: ExitReportButtonProps) => {
  const {
    modules: {
      SHIFT_REPORT: { hasManagerReadPermission },
    },
  } = usePermissions();

  if (hasManagerReadPermission) {
    if (managerRoute) {
      return (
        <Link to={managerRoute}>
          <Button {...buttonProps} icon={<CloseOutlined />}>
            {t('common.close')}
          </Button>
        </Link>
      );
    }

    return (
      <Link to={Routes.ReportDashboardVisualize}>
        <Button {...buttonProps} icon={<CloseOutlined />}>
          {t('common.close')}
        </Button>
      </Link>
    );
  }

  if (previousLocation) {
    return (
      <Link to={previousLocation}>
        <Button {...buttonProps} icon={<CloseOutlined />}>
          {t('common.close')}
        </Button>
      </Link>
    );
  }

  return (
    <Link to={Routes.ReportUserHome}>
      <Button {...buttonProps} icon={<CloseOutlined />}>
        {t('common.close')}
      </Button>
    </Link>
  );
};

export default ExitReportButton;
